import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Spine } from "pixi-spine";
import { Container } from "pixi.js";

export class ReelFrames extends View {
    private dragonsFrame: Container;
    private pandasFrame: Container;
    private dragonsDividerFrames!: Container;
    private pandasDividerFrames!: Container;
    private dragonsDividerFramesNeon!: Container;
    private pandasDividerFramesNeon!: Container;
    private dragonsFlame!: Spine & Container;
    private pandasLightning!: Spine & Container;

    constructor(protected override readonly services: GameServices, spec: Record<string, any>) {
        super(services);

        const {factory, resources} = this.services;
        const {flamesTimeScale, lightningTimeScale} = resources.getSetting(`reelFrames`);

        this.dragonsFrame = this.setupFrame(spec.dragonsFrame);
        this.pandasFrame = this.setupFrame(spec.pandasFrame);

        this.dragonsDividerFrames = factory.createContainer({}, this.dragonsFrame);
        this.pandasDividerFrames = factory.createContainer({}, this.pandasFrame);
        this.dragonsDividerFramesNeon = factory.createContainer({}, this.dragonsFrame);
        this.pandasDividerFramesNeon = factory.createContainer({}, this.pandasFrame);

        this.dragonsFlame = factory.createSpine(spec.dragonsReels.flameSpine.frameDragon, this);
        this.dragonsFlame.state.timeScale = flamesTimeScale;
        this.pandasLightning = factory.createSpine(spec.pandasReels.flameSpine.framePanda, this);
        this.pandasLightning.state.timeScale = lightningTimeScale;

        this.setupDividerFrames(spec);
        this.setupNeonDividers();
        this.setupBaseFlames();
        this.startFlameAnimation();
    }

    private setupFrame(spec: Record<string, any>): Container {

        const {factory} = this.services;

        const container = factory.createContainer(spec, this);

        for (const childName of Object.keys(spec.slices)) {
            factory.createSprite(spec.slices[childName], container);
        }

        return container;
    }

    private setupDividerFrames(spec: Record<string, any>)
    {
        const {factory} = this.services;

        factory.createSprite(spec.dragonDividerFrames.dragonsReelDivider1, this.dragonsDividerFrames);
        factory.createSprite(spec.dragonDividerFrames.dragonsReelDivider2, this.dragonsDividerFrames);
        factory.createSprite(spec.dragonDividerFrames.dragonsReelDivider3, this.dragonsDividerFrames);

        factory.createSprite(spec.pandaDividerFrames.pandasReelDivider1, this.pandasDividerFrames);
        factory.createSprite(spec.pandaDividerFrames.pandasReelDivider2, this.pandasDividerFrames);
        factory.createSprite(spec.pandaDividerFrames.pandasReelDivider3, this.pandasDividerFrames);

        factory.createSprite(spec.dragonDividerFramesNeon.dragonsReelDivider1Neon, this.dragonsDividerFramesNeon);
        factory.createSprite(spec.dragonDividerFramesNeon.dragonsReelDivider2Neon, this.dragonsDividerFramesNeon);
        factory.createSprite(spec.dragonDividerFramesNeon.dragonsReelDivider3Neon, this.dragonsDividerFramesNeon);

        factory.createSprite(spec.pandaDividerFramesNeon.pandasReelDivider1Neon, this.pandasDividerFramesNeon);
        factory.createSprite(spec.pandaDividerFramesNeon.pandasReelDivider2Neon, this.pandasDividerFramesNeon);
        factory.createSprite(spec.pandaDividerFramesNeon.pandasReelDivider3Neon, this.pandasDividerFramesNeon);
    }

    private startFlameAnimation(): void {
        this.dragonsFlame?.state.setAnimation(0, `reel-idle-outer`, true);
        this.pandasLightning?.state.setAnimation(0, `reel-idle-outer`, true);
    }

    setupNeonDividers(): void {
        this.dragonsDividerFrames.visible = false;
        this.pandasDividerFrames.visible = false;

        this.dragonsDividerFramesNeon.visible = true;
        this.pandasDividerFramesNeon.visible = true;
    }

    setupNormalDividers(): void {
        this.dragonsDividerFrames.visible = true;
        this.pandasDividerFrames.visible = true;

        this.dragonsDividerFramesNeon.visible = false;
        this.pandasDividerFramesNeon.visible = false;
    }

    setupBaseFlames(): void {
        this.dragonsFlame.visible = true;
        this.pandasLightning.visible = true;
        this.dragonsFlame.state.setAnimation(0, `reel-idle-outer`, true);
        this.pandasLightning.state.setAnimation(0, `reel-idle-outer`, true);
    }

    setupVSDragonFlames(): void {
        this.dragonsFlame.visible = true;
        this.pandasLightning.visible = false;
        this.dragonsFlame.state.setAnimation(0, `reel-idle-full`, true);
    }

    setupVSPandaFlames(): void {
        this.dragonsFlame.visible = false;
        this.pandasLightning.visible = true;
        this.pandasLightning.state.setAnimation(0, `reel-idle-full`, true);
    }

    setupFreeGamesFrames(): void {
        this.dragonsFlame.visible = false;
        this.pandasLightning.visible = false;
        this.setupNormalDividers();
    }
}